<template>
    <div class="subscribe">
        <div class="row row--fullwidth">
            <div class="col lg-6 sm-12">
                <h1 class="text_19 subscribe__title">{{ $t("sale_subscribe_page_title") }}</h1>
                <Subscribe
                    show-success-message
                    hideLabel
                    showSubmit
                    :target="$route.query.tag || 'sales-subscribe'"
                    :success-message="$t('sale_subscribe_success')"></Subscribe>
            </div>
            <div class="col lg-6 sm-12 col--no-padding subscribe-img">
                <UiImage :path="img" :desktop="{ width: 1016 }" :lazy="false" />
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import UiImage from "@/components/ui/Image.vue";
import Subscribe from "@/components/Subscribe.vue";

export default {
    name: "SymbiosSubscribe",
    components: {
        UiImage,
        Subscribe,
    },
    async asyncData({ $axios }) {
        try {
            return {
                img: (await $axios.get("/api/page-images/sale-subscribe")).data.img,
            };
        } catch (e) {
            console.log(e);
        }
    },
    data() {
        return {
            img: null,
        };
    },
    computed: {
        ...mapGetters({
            langust: "globalvars/getLang",
        }),
    },
    methods: {
        getCrumbs() {
            return [
                {
                    name: this.$i18n.t("subscribe_sale_mail"),
                },
            ];
        },
    },
    watch: {
        langust() {
            this.$store.commit("crumbs/change", this.getCrumbs());
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.getCrumbs());
    },
};
</script>
<style lang="less" scoped>
.subscribe {
    z-index: 1;
    background: #fff;

    &__title {
        padding-top: 24px;
        margin-bottom: 24px;
    }
    &-img {
        img {
            width: 100%;
        }
    }
}
</style>
